/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Button, Form, message, Select, Spin } from "antd";
import Smcs_Loader from "../../assests/images/loader-new.gif";

import Heading from "../CpOnboardingNew/Heading";
import { customerOnboardingAPI } from "../../api/LeadApi";
import BankDetails from "../../components/BankDetails";

import CreateKYC from "../../components/CreateKYC";
import {
  checkAlphabets,
  checkSpecialCharacter,
  checkSpace,
  capitalize,
  checkNumbervalue,
} from "../../utils";

const currentEnv = process.env.REACT_APP_ENV;
export const DefaultCompany = ({
  handleStepsChange = () => {},
  getData,
  goBackStep,
  hideGst,
  hideAadhaar,
  hidePan,
  hideTan,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);
  const [customerId, setCustomerId] = useState(
    JSON.parse(localStorage.getItem("selectedCompany")) ||
      JSON.parse(localStorage.getItem("customerId"))
  );

  const typeOfBusinessOptions = [
    {
      value: "Individual",
      label: "Individual",
    },
    {
      value: "Proprietorship",
      label: "Proprietorship",
    },
    {
      value: "Private limited",
      label: "Private limited",
    },
    {
      value: "Public limited",
      label: "Public limited",
    },
    {
      value: "LLP",
      label: "LLP",
    },
    {
      value: "Partnership",
      label: "Partnership",
    },
  ];

  useEffect(() => {
    setLoading(true);
    //if (getData?.addresses?.find((e) => e?.type === "gstAddress")) {
    const GST =
      getData?.kycDocuments.find((doc) => doc.idType === "GST")?.idNumber ||
      null;
    const PAN =
      getData?.kycDocuments.find((doc) => doc.idType === "PAN")?.idNumber ||
      null;
    const AADHAR =
      getData?.kycDocuments.find((doc) => doc.idType === "AADHAR")?.idNumber ||
      null;

    const TAN =
      getData?.kycDocuments.find((doc) => doc.idType === "TAN")?.idNumber ||
      null;

    // const address = getData?.addresses?.find(
    //   (e) => e?.type?.toUpperCase() === "DEFAULT"
    // );
    // const contactNumber = getData?.contactNumbers?.find(
    //   (e) => e?.type?.toUpperCase() === "DEFAULT"
    // )?.number;
    const address = getData?.addresses?.find(
      (e) => e?.type?.toUpperCase() === "COMPANY"
    );
    const contactNumber = getData?.contactNumbers?.find(
      (e) => e?.type?.toUpperCase() === "COMPANY"
    )?.number;

    form.setFieldsValue({
      companyName: getData?.businessDetail?.companyName,
      GST,
      PAN,
      AADHAR,
      TAN,
      businessName: getData?.businessDetail?.businessName || null,
      natureOfBusiness: getData?.businessDetail?.natureOfBusiness || null,
      contactNumber: contactNumber || null,
      bankDetails: getData?.bankDetails || [],
      gstRegistred: getData?.kycDocuments?.length === 0 || GST ? true : false,
      line1: `${address?.street} ${address?.city} ${address?.state}`,
      street: `${address?.street || ""}`,
      area: `${address?.area || ""}`,
      line2: address?.area || "",
      pincode: address?.pincode,
    });
    setLoading(false);
    //}
    setLoading(false);
  }, [getData]);

  const createCompanyDetails = async (values) => {
    const checkBtn = clickedButton === "saveAndContinueButton";

    // const res = await API.Api(
    //   UPDATE_LEAD_CP_DETAILS + "/" + lead
    // ).putCustomHeader(
    //   { companyDetail: values, leadId: lead },
    //   { "USER-ID": userId?.userInfo?.userId }
    // );

    let payload = {
      businessDetail: {
        companyName: values?.companyName,
        natureOfBusiness: values?.natureOfBusiness,
        businessName: values?.businessName,
        // contactNumber: values?.contactNumber,
      },
      contactNumbers: [
        {
          type: "COMPANY",
          country: "IN",
          number: values?.contactNumber,
          isVerified: true,
        },
      ],
      organizationName: values?.organizationName,
      bankDetails: values?.bankDetails,
      addresses: [
        {
          // line1: values?.line1,
          // line2: values?.line2,
          street: values?.line1 || values?.street,
          area: values?.line2 || values?.area,
          // postalCode: values?.pincode,
          pincode: values?.pincode,
          // type: "gstAddress",
          type: "COMPANY",
        },
      ],
      kycDocuments: [
        {
          idType: "GST",
          idNumber: values?.GST,
        },
        {
          idType: "PAN",
          idNumber: values?.PAN,
        },
        {
          idType: "AADHAR",
          idNumber: values?.AADHAR,
        },
        {
          idType: "TAN",
          idNumber: values?.TAN,
        },
      ].filter((doc) => doc.idNumber),
    };
    setLoading(true);

    let getRols = JSON.parse(localStorage.getItem("userinfo"));
    const getRole = getRols?.roles[0];

    let res;
    console.log(localStorage.getItem("customerId"));

    if (
      getRole === "ROLE_CPADMIN" &&
      currentEnv === "prod"
      //  &&
      // JSON.parse(localStorage.getItem("isEnableCP") )
    ) {
      res = await customerOnboardingAPI.patchCompany(customerId?.newCompanyId, {
        customer: payload,
      });
    } else if (
      currentEnv === "qa" &&
      !JSON.parse(localStorage.getItem("isEnableCP")) &&
      (getRole === "ROLE_CPADMIN" || getRole === "ROLE_HOMARKETING")
    ) {
      res = await customerOnboardingAPI.patchLead(
        localStorage.getItem("customerId"),

        payload
      );
    } else {
      res = await customerOnboardingAPI.patchCompany(customerId?.newCompanyId, {
        customer: payload,
      });
    }

    if (res?.status) {
      setLoading(false);
      message.success("Company details added successfully");
      if (checkBtn) {
        handleStepsChange(1);
      }
    } else {
      setLoading(false);
      message.error(res?.response?.data?.message || "Internal server error");
    }
  };

  return (
    <Spin
      spinning={loading}
      size="large"
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div>
        <Form
          id="myForm"
          className="global-form profile-container-form pl-4 pr-4 p-2"
          layout="vertical"
          form={form}
          onFinishFailed={({ errorFields }) => {
            console.log(errorFields, "errorFields");
            if (errorFields?.length > 0) {
              const firstErrorField = errorFields[0]?.name?.[0];
              const firstElement = document.getElementById(firstErrorField);
              if (firstElement) {
                firstElement.focus();
              }
            }
          }}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createCompanyDetails}
          initialValues={{ gstRegistred: true }}
        >
          <Row gutter={40} className="global-form-row">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="companyName"
                label="Company Name"
                rules={[{ required: true, message: "Please enter name" }]}
              >
                <Input
                  placeholder="Enter name"
                  maxLength={40}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="gstNo"
                label="GST Number"
                //rules={[{ required: true, message: "Please enter GST number" }]}
              >
                <Input
                  placeholder="Enter GST number"
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="panNumber"
                label="PAN Number"
                //rules={[{ required: true, message: "Please enter PAN number" }]}
              >
                <Input
                  placeholder="Enter PAN number"
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="adharNo"
                label="Aadhar Number"
                // rules={[
                //   { required: true, message: "Please enter Aadhar number" },
                // ]}
              >
                <Input
                  placeholder="Enter Aadhar number"
                  maxLength={12}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col> */}
            <CreateKYC
              orgName={"Company"}
              form={form}
              orgType={"companyName"}
              getData={getData}
              hideGst={hideGst}
              hideAadhaar={hideAadhaar}
              hidePan={hidePan}
              hideTan={hideTan}
            />

            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="natureOfBusiness"
                label="Business Type"
                rules={[
                  { required: true, message: "Please select business type" },
                ]}
              >
                <Select
                  placeholder="Select business type"
                  options={typeOfBusinessOptions}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="contactNumber"
                label="Contact Number"
                // rules={[
                //   { required: true, message: "Please enter contact number" },
                // ]}

                rules={[
                  { required: true, message: "Please enter contact number" },
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message:
                      "Contact number should start with 6-9 and be 10 digits",
                  },
                  // {
                  //   validator(_, val = "") {
                  //     if (val.length > 0 && val?.length < 10) {
                  //       return Promise.reject(
                  //         new Error("Contact number should be 10 digits")
                  //       );
                  //     }

                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
              >
                <Input
                  placeholder="Enter contact number"
                  maxLength={10}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  onChange={(e) => {
                    if (checkNumbervalue(e)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="businessName"
                label="Business Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter business name",
                    validateTrigger: "onSubmit",
                  },
                  {
                    pattern: /^(?=.*[a-zA-Z])[a-zA-Z0-9\s]*$/,
                    message: "Business name must contain at least one letter",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.trim().length === 0) {
                        return Promise.reject("Please enter business name");
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Enter business name"
                  maxLength={40}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Heading title="Bank Details" />
            </Col>

            <Col span={24}>
              <BankDetails
                disabled={getData?.status?.toLowerCase() === "approved"}
                form={form}
              />
            </Col>
          </Row>
          <hr className="divider" />
          <div className="flex-end mt-1">
            <Button
              className="cancel-btn ml-1 w-15"
              id="save"
              onClick={goBackStep}
            >
              BACK
            </Button>
            {getData?.status?.toLowerCase() !== "approved" ? (
              <>
                <Button htmlType="submit" className="cancel-btn ml-1 w-15">
                  SAVE
                </Button>
                <Button
                  htmlType="submit"
                  id="saveNContinue"
                  onClick={() => setClickedButton("saveAndContinueButton")}
                  className="save-btn  ml-1"
                >
                  SAVE & CONTINUE
                </Button>
              </>
            ) : (
              <Button
                id="saveNContinue"
                onClick={() => handleStepsChange(1)}
                className="save-btn  ml-1"
              >
                NEXT
              </Button>
            )}
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default DefaultCompany;
